module.exports = __webpack_public_path__ + "static/media/400004_01.7730ba2a.png";